import { IMobileScansListSummary } from 'src/apps/mobile-common/services/mobile-scans-list';

const TABLE_TITLE = 'MFA Session Scans';

const formatSummary = ({
	scansCount,
	issuesCount,
	elementsWithIssuesCount
}: IMobileScansListSummary): string =>
	`${scansCount} scans, ${issuesCount} issues, ${elementsWithIssuesCount} elements with issues`;

export const MFA_SESSION_SCANS_LABELS = {
	SECTION_ARIA_LABEL: "MFA Session's scans",
	FILTERS_ARIA_LABEL: "MFA Session's scans filters",
	TABLE_ARIA_LABEL: "MFA Session's scans table",
	TABLE_CAPTION: 'MFA Session Scans table',
	SCREENSHOT: 'Screenshot',
	SCAN_NAME: 'Scan name',
	TOTAL_ISSUES: 'Total Issues',
	CRITICAL: 'Critical',
	SERIOUS: 'Serious',
	ELEMENTS_WITH_ISSUES: 'Elements with issues',
	NO_SCREENSHOT: 'No screenshot available',
	SCAN_NAME_LINK_ARIA_LABEL: (scanName: string): string =>
		`Open All Issues filtered by ${scanName}`,
	SCREENSHOT_ALT: (scanName: string): string => `${scanName} scan screenshot`,
	ISSUES_ELEMENTS_SUMMARY: ({
		issuesCount,
		elementsWithIssuesCount
	}: IMobileScansListSummary): string =>
		` | ${issuesCount} issues | ${elementsWithIssuesCount} elements`,
	TABLE_TITLE_WITH_SUMMARY: (summary: IMobileScansListSummary): string =>
		`${TABLE_TITLE} (${formatSummary(summary)})`
} as const;
